import { TextStyleProps } from '@dtx-company/shared-components/src'

export enum PlatformNavIcons {
  Studio = 'studio',
  Forms = 'forms',
  Flowcode = 'flowcode',
  Flowpage = 'flowpage',
  Flowtag = 'flowtag',
  Folder = 'folder',
  Analytics = 'analytics',
  Reports = 'reports',
  Store = 'store',
  Org = 'org',
  Domains = 'domains',
  Rocket = 'rocket',
  Profile = 'profile',
  Help = 'help',
  Logout = 'logout',
  ProfileOutline = 'profileoutline',
  RocketOutline = 'rocketoutline',
  Book = 'book',
  HelpOutline = 'helpoutline',
  BookFilled = 'bookfilled',
  Components = 'components',
  AutoDesign = 'autodesign',
  PhotoAdd = 'photoadd',
  VideoOverlay = 'video-overlay',
  Templates = 'templates',
  Trash = 'trash',
  Bundles = 'bundles'
}

export interface LeftNavDropdownMenuItem extends TextStyleProps {
  text?: string
  link?: string
  action?: () => void
  highlightDefault?: boolean
  disabled?: boolean
  tooltipText?: string
  /**
   * Sets the title attribute on a menu item. This will help avoid cases where tooltips are truncated due to being in an overflow container.
   */
  titleText?: string
}
